import React, { useContext, useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';

const User_Approval = () => {
    const [Users, setUsers] = useState([])
    const [TotalPage, setTotalPage] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(1)
    const [PageData, setPageData] = useState([])
    const [UserModal, setUserModal] = useState(false)
    const [UserObject, setUserObject] = useState({ 'site_name_list': [] })
    const Entries = 12
    function GetUsers() {
        var url = window.API_PREFIX + "Admin/api/get/all/users";
        const requestOptions = {
            data: sessionStorage.getItem("token")
        };
        axios
            .post(url, requestOptions)
            .then((res) => {
                if (res.status == 200) {
                    setUsers(res.data.user)
                    setTotalPage((res.data.user.length % Entries) == 0 ? (res.data.user.length / Entries) : parseInt(res.data.user.length / Entries) + 1)

                    // setPageData(SearchResult.slice((CurrentPage - 2) * Entries, (CurrentPage - 1) * Entries))

                    setPageData(res.data.user.slice((CurrentPage - 1) * Entries, (CurrentPage) * Entries))
                }
            })
    }

    function ChangeAccountStatus() {
        var url = window.API_PREFIX + 'Admin/api/change_profile_policy';
        const requestOptions = {

            token: sessionStorage.getItem("token"),
            payload: UserObject

        };
        axios
            .post(url, requestOptions)
            .then((res) => {
                if (res.status == 200) {
                    GetUsers()
                }
            })
    }

    useEffect(() => {
        GetUsers();
    }, [])
    return (
        <>
            <div>
                <Paper sx={{ width: '100%', overflow: 'hidden'}}>
                    <TableContainer sx={{ maxHeight: 700 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell key="user_name" ><b>User name</b></TableCell>
                                    <TableCell key="Email"> <b>Email</b></TableCell>
                                    <TableCell key="Role"> <b>Role</b></TableCell>

                                    <TableCell key="Action"> <b>Action</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {PageData.map((row) => {
                                    return (
                                        <TableRow hover >
                                            <TableCell key={row.name} ><b>{row.username}</b> </TableCell>
                                            <TableCell key={row.email} >{row.email} </TableCell>
                                            <TableCell key={row.role} >
                                                {row.role}
                                            </TableCell>

                                            <TableCell key='action' >
                                                <Button variant="contained" endIcon={<SendIcon />} onClick={(e) => {
                                                    var x = {}
                                                    var keylist = Object.keys(row)
                                                    for (var i = 0; i < keylist.length; i++) {
                                                        x[keylist[i]] = row[keylist[i]]
                                                    }
                                                    setUserObject(x)
                                                    setUserModal(true)

                                                }}>
                                                    Manage
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </Paper>
            </div>
            <div>
                <Modal show={UserModal} onHide={(e) => { setUserModal(false) }} size='mg' >
                    <Modal.Header closeButton >
                        <Modal.Title>{UserObject.name}</Modal.Title>

                    </Modal.Header>

                    <Modal.Body>
                        <form>
                            <div className="row form-group">
                                <FormControl>
                                    <FormLabel id="demo-radio-buttons-group-label"><b>Last changed by</b></FormLabel>
                                    <input type="text" class="form-control " disabled defaultValue={UserObject.approvedBy}
                                    />
                                </FormControl>
                                <br />
                                <br />
                                <FormControl>
                                    <FormLabel id="role-group-label" sx={{ marginBottom: -0.9 }}><b>Role</b></FormLabel>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue={UserObject.role}
                                        name="role"
                                        onChange={(e) => {
                                            var x = UserObject
                                            x.role = e.target.value
                                            setUserObject(x)

                                        }}
                                    >
                                        <FormControlLabel value="Student" control={<Radio />} sx={{ marginBottom: -1.6 }} label="Student" />
                                        <FormControlLabel value="Verifier" control={<Radio />} sx={{ marginBottom: -1.6 }} label="Verifier" />
                                        <FormControlLabel value="Interactor" control={<Radio />} sx={{ marginBottom: -1.6 }} label="Interactor" />
                                        <FormControlLabel value="Director" control={<Radio />} sx={{ marginBottom: -1.6 }} label="Director" />
                                        <FormControlLabel value="Admin" control={<Radio />} sx={{ marginBottom: -1.6 }} label="Admin" />
                                        <FormControlLabel value="Unknown" control={<Radio />} sx={{ marginBottom: -1.6 }} label="Unknown" />

                                    </RadioGroup>
                                </FormControl>
                                <br />
                                <FormControl>
                                    <FormLabel id="demo-radio-buttons-group-label" sx={{ marginBottom: -0.9 }}><b>Account status</b></FormLabel>
                                    <RadioGroup
                                        aria-labelledby="account-status-group-label"
                                        defaultValue={UserObject.isApproved}
                                        name="account_status"
                                        onChange={(e) => {
                                            var x = UserObject
                                            x.isApproved = e.target.value
                                            setUserObject(x)

                                        }}
                                    >
                                        <FormControlLabel value="Online" control={<Radio />} sx={{ marginBottom: -1.6 }} label="Online" />
                                        <FormControlLabel value="Waiting for approval" control={<Radio />} sx={{ marginBottom: -1.6 }} label="Waiting for approval" />
                                        {/* <FormControlLabel value="blocked" control={<Radio />} sx={{ marginBottom: -1.6 }} label="blocked" /> */}

                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <button className="btn btn-primary"
                                onClick={(e) => {
                                    var flag = true

                                    if (UserObject.isApproved == 'online') {
                                        if (UserObject.role != 'admin') {
                                            flag = false
                                        }
                                    }
                                    if (flag) {
                                        var tmp_userobject = UserObject
                                        setUserObject({ ...tmp_userobject })
                                        ChangeAccountStatus()
                                        setUserModal(false)
                                    }

                                    e.preventDefault()
                                }}
                            >
                                save
                            </button>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )
}

export default User_Approval;